var _path, _path2, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2555 18.1617C46.3572 19.3741 45.4569 20.4395 44.2444 20.5413L10.2359 23.8343L21.3756 31.1892C22.3909 31.8596 22.6706 33.2262 22.0002 34.2416C21.3298 35.2569 19.9632 35.5366 18.9478 34.8662L2.50409 24.0091C1.72081 23.492 1.35121 22.5353 1.58333 21.6258C1.81546 20.7164 2.59832 20.0539 3.53365 19.9753L43.8758 16.1507C45.0883 16.0489 46.1537 16.9493 46.2555 18.1617Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2564 18.1616C45.2573 17.4672 43.8845 17.7143 43.1901 18.7134L22.6267 46.9888L20.4274 33.7673C20.2278 32.5671 19.093 31.7559 17.8928 31.9556C16.6925 32.1552 15.8814 33.29 16.0811 34.4902L19.1696 53.0579C19.3166 53.9421 19.9848 54.6491 20.8593 54.8458C21.7338 55.0425 22.6403 54.6898 23.1518 53.9537L46.8082 21.2279C47.5026 20.2288 47.2555 18.856 46.2564 18.1616Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.5239,
    cy: 19.1613,
    rx: 3,
    ry: 3,
    transform: "rotate(-30 44.5239 19.1613)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPointer);
export default __webpack_public_path__ + "static/media/arrow-pointer.93dc2b05d6f245c3fdf6de0de08e60d9.svg";
export { ForwardRef as ReactComponent };